import styled from 'styled-components';

const StyledArticleMeta = styled.div`
  color: white;
  font-size: 1.3rem;

  .detail:not(:last-child) {
    margin-right: 1em;
    padding-right: 1em;
    border-right: 1px solid ${({ theme }) => theme.primaryLink};
  }
`;

export const ArticleMeta = ({ author, date, containerClassName, detailClassName }) => {
  return (
    <StyledArticleMeta className={containerClassName}>
      <span className={`detail ${detailClassName}`}>
        By <span>{author?.name}</span>
      </span>
      <span className={`detail ${detailClassName}`}>{new Date(date).toDateString()}</span>
      <span className={`detail ${detailClassName}`}>3 minutes read</span>
    </StyledArticleMeta>
  );
};
